var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M777 360L777 388",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 777.5,
    cy: 355.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M772.987 355.19C772.987 351.283 776.288 348.117 780.358 348.117C780.943 348.117 781.511 348.184 782.056 348.308C780.742 347.48 779.187 347 777.519 347C772.814 347 769 350.806 769 355.5C769 360.194 772.814 364 777.519 364C779.814 364 781.895 363.093 783.427 361.62C782.492 362.032 781.454 362.263 780.358 362.263C776.288 362.263 772.987 359.096 772.987 355.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M786.402 354.6L786.37 352.146L784.535 353.719L782.304 353.056L783.112 355.337L781.765 357.381L784.1 357.218L785.499 359.144L786.133 356.763L788.345 355.909L786.402 354.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.e4bccc1a17e77b8a0300a43b84148886.svg";
export { ForwardRef as ReactComponent };